import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log for debugging in console; replace with server logging if needed.
    console.error('Tech app crashed:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center px-6">
          <div className="max-w-md w-full text-center space-y-4">
            <div className="mx-auto h-12 w-12 rounded-2xl bg-primary-600 text-white flex items-center justify-center text-lg font-semibold">
              KR
            </div>
            <h1 className="text-2xl font-bold text-gray-900">Something went wrong</h1>
            <p className="text-base text-gray-600">
              Please close the app and reopen it. If this keeps happening, contact support.
            </p>
            <button onClick={this.handleReload} className="btn btn-primary">
              Reload App
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
